import {
  addNewRule,
  executeRule,
  getExecutionRulesHistory,
  getRulesListByDomainIdUrl,
  getRulesListUrl,
  getRuleDetailById,
  updateRuleById,
  getPaginatedRulesListUrl,
  getRuleBackupUrl,
  validateImportedRuleUrl,
  getRuleResultByRuleIdUrl,
  getResearchQueryDetailByRuleId,
  addNewResearchQuery,
  updateResearchQueryById,
  getMissingResultByRuleResultIdUrl,
  getMismatchResultByRuleResultIdUrl,
  getAdhocQueryResultByRuleResultIdUrl,
  getResearchQueryResultByRuleResultIdUrl,
  getMismatchRecordsWithIssuesByExecutionIdUrl,
  getMissingRecordsWithIssuesByExecutionIdUrl,
  executeRuleReRunUrl,
  deleteRuleExecutionbyIdUrl,
  abortExecutionbyIdUrl,
  getLatestExecutionPayload,
  backroundExecuteRule,
  backgroundExecuteRuleReRunUrl,
  getTableColumnsUrl,
  getUsedVariablesUrl,
  getRuleExecutionJobStatusUrl,
  cloneRuleUrl,
  getMissingRecordsWithSnapshotsByExecutionIdUrl,
  getMismatchRecordsWithSnapshotsByExecutionIdUrl,
  reactivateRuleUrl,
  getRuleParamsUrl,
} from "./constants";
import { IExecuteRuleData } from "../types/rules";
import base from "../middlewares/interceptors";
import { getConfig } from "../config/runtimeConfig";

export const getRulesList = async (filters?: {
  rule_name?: string;
  rule_filter_ids?: number | string;
  is_active?: boolean;
  comparison_research_query_available?: boolean;
  is_score_config_associated?: boolean;
}) => {
  try {
    const params: { [key: string]: any } = {};

    // Add filter params if provided
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          params[key] = value;
        }
      });
    }

    // Build query string
    const queryString = Object.entries(params)
      .map(([key, value]) => {
        if (key === "rule_name") {
          // For rule_name, use encodeURIComponent to properly encode special characters
          return `${key}=${encodeURIComponent(value)}`;
        }
        // For other parameters, use standard encoding
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join("&");

    const requestUrl = queryString
      ? `${getRulesListUrl}/all?${queryString}`
      : `${getRulesListUrl}`;

    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getRulesListByDomainId = async (
  domainId: number,
  filters?: { is_score_config_associated?: boolean },
) => {
  try {
    let requestUrl = `${getRulesListByDomainIdUrl}/${domainId}/rules`;
    if (filters?.is_score_config_associated !== undefined) {
      requestUrl += `?is_score_config_associated=${filters.is_score_config_associated}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const createRule = async (reqBody: any) => {
  try {
    const response = await base.post(addNewRule, reqBody);
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

// const buildQueryString = (params: any) => {
//   return Object.keys(params)
//     .filter(
//       (key) => key !== "validation_severity_level" && key !== "run_instance"
//     )
//     .map(
//       (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
//     )
//     .join("&");
// };

export const executeRuleById = async (
  ruleId: number,
  reqBody: IExecuteRuleData,
) => {
  try {
    // const queryString = buildQueryString(runParameters);
    const response = await base.post(`${executeRule}/${ruleId}`, reqBody);
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
export const executeRuleReRun = async (reqBody: any) => {
  try {
    const response = await base.post(`${executeRuleReRunUrl}`, reqBody);
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export const backgroundexecuteRuleById = async (
  ruleId: number,
  reqBody: IExecuteRuleData,
) => {
  try {
    // const queryString = buildQueryString(runParameters);
    const response = await base.post(
      `${backroundExecuteRule}/${ruleId}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
export const backgroundExecuteRuleReRun = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${backgroundExecuteRuleReRunUrl}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export const executionHistory = async () => {
  try {
    const response = await base.get(getExecutionRulesHistory);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteRule = async (currentRuleId: number) => {
  try {
    const response = await base.delete(`${updateRuleById}/${currentRuleId}`);
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
  }
};

export const getRuleDetail = async (currentRuleId: number) => {
  try {
    const response = await base.get(`${getRuleDetailById}/${currentRuleId}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateRule = async ({ currentRuleId, payload }: any) => {
  try {
    // Extract comment from rule to use as query parameter
    const comment = payload?.rule?.comment?.trim();

    // Remove comment from the payload body
    const { rule, ...restPayload } = payload;
    const { comment: _, ...ruleWithoutComment } = rule || {};

    const payloadWithoutComment = {
      ...restPayload,
      rule: ruleWithoutComment,
    };

    // Build request URL with comment as query parameter if present
    const requestUrl = comment
      ? `${updateRuleById}/${currentRuleId}?comment=${encodeURIComponent(
          comment,
        )}`
      : `${updateRuleById}/${currentRuleId}`;

    const response = await base.put(requestUrl, payloadWithoutComment);

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPaginatedRulesList = async ({
  currentDomainId,
  page,
  pSize,
  searchFilterData,
}: any) => {
  try {
    const defaultPage = getConfig("REACT_APP_DEFAULT_PAGE", "1");
    const defaultPageSize = getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25");

    const pageN = page || defaultPage;
    const pageSize = pSize || defaultPageSize;

    const params: { [key: string]: any } = {
      page: pageN,
      size: pageSize,
    };

    if (currentDomainId && currentDomainId !== 0) {
      params["domain_id"] = currentDomainId;
    }
    // Add searchFilterData params
    if (searchFilterData && Object.keys(searchFilterData).length > 0) {
      Object.entries(searchFilterData).forEach(
        ([key, value]: [string, any]) => {
          if (key && value !== null) {
            const trimmedValue =
              typeof value === "string" ? value.trim() : value;
            if (trimmedValue !== "") {
              params[key] = trimmedValue;
            }
          }
        },
      );
    }

    // Build URL manually to handle special characters in rule_name properly
    const queryString = Object.entries(params)
      .map(([key, value]) => {
        if (key === "rule_name") {
          // For rule_name, use encodeURIComponent to properly encode special characters
          return `${key}=${encodeURIComponent(value)}`;
        }
        // For other parameters, use standard encoding
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join("&");

    const requestUrl = `${getPaginatedRulesListUrl}?${queryString}`;
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getRuleBackup = async ({ ruleId, page, pSize }: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;

    let requestUrl;
    if (ruleId && ruleId !== 0) {
      requestUrl = `${getRuleBackupUrl}?rule_backup_filter_ids=${ruleId}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ValidateImportedRule = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${validateImportedRuleUrl}/${reqBody?.entity_description?.id}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getRuleResultByRuleId = async ({ currentRuleResultId }: any) => {
  try {
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getRuleResultByRuleIdUrl}/${currentRuleResultId}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getRuleParams = async ({ currentRuleResultId }: any) => {
  try {
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getRuleParamsUrl}/${currentRuleResultId}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getResearchQueryDetail = async (currentRuleId: number) => {
  try {
    const response = await base.get(
      `${getResearchQueryDetailByRuleId}/${currentRuleId}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const addResearchQuery = async (reqBody: any) => {
  try {
    const response = await base.post(addNewResearchQuery, reqBody);
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

export const updateResearchQuery = async ({
  currentResearchQueryId,
  payload,
}: any) => {
  try {
    // Extract comment from payload to use as query parameter
    const comment = payload?.comparison_research_query?.comment?.trim();

    // Remove comment from the payload body
    const { comparison_research_query, ...restPayload } = payload;
    const { comment: _, ...rqWithoutComment } = comparison_research_query || {};
    const payloadWithoutComment = {
      ...restPayload,
      comparison_research_query: rqWithoutComment,
    };

    // Build request URL with comment as query parameter if present
    const requestUrl = comment
      ? `${updateResearchQueryById}/${currentResearchQueryId}?comment=${encodeURIComponent(
          comment,
        )}`
      : `${updateResearchQueryById}/${currentResearchQueryId}`;

    const response = await base.put(requestUrl, payloadWithoutComment);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getTableColumns = async ({ payload }: any) => {
  try {
    const response = await base.post(`${getTableColumnsUrl}`, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * For missing records
 */

export const getMissingRuleResultByRuleResultId = async ({
  currentRuleResultId,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getMissingResultByRuleResultIdUrl}/${currentRuleResultId}?page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getMissingRecordsWithIssuesByExecutionId = async ({
  currentRuleResultId,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getMissingRecordsWithIssuesByExecutionIdUrl}/pages?execution_id=${currentRuleResultId}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getMissingRecordsWithSnapshotsByExecutionId = async ({
  currentRuleResultId,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getMissingRecordsWithSnapshotsByExecutionIdUrl}/${currentRuleResultId}?page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * For Mismatch records
 */

export const getMismatchRuleResultByRuleResultId = async ({
  currentRuleResultId,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getMismatchResultByRuleResultIdUrl}/${currentRuleResultId}?page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getMismatchRecordsWithIssuesByExecutionId = async ({
  currentRuleResultId,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getMismatchRecordsWithIssuesByExecutionIdUrl}/pages?execution_id=${currentRuleResultId}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getMismatchRecordsWithSnapshotsByExecutionId = async ({
  currentRuleResultId,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getMismatchRecordsWithSnapshotsByExecutionIdUrl}/${currentRuleResultId}?page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * For Adhoc query records
 */

export const getAdhocQueryResultByRuleResultId = async ({
  currentRuleResultId,
  pageN,
  pageS,
  queryName,
}: any) => {
  try {
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getAdhocQueryResultByRuleResultIdUrl}/${currentRuleResultId}?name=${queryName}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * For Research Query Records
 */

export const getResearchQueryRuleResultByRuleResultId = async ({
  currentRuleResultId,
  pageN,
  pageS,
  queryName,
}: any) => {
  try {
    let requestUrl;
    if (currentRuleResultId && currentRuleResultId !== 0) {
      requestUrl = `${getResearchQueryResultByRuleResultIdUrl}/${currentRuleResultId}?name=${queryName}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Gets comparison rerun result for a given execution ID
 * @param executionId - The ID of the execution to get results for
 * @returns The comparison rerun result data
 * @throws Error if request fails
 */
export const getComparisonRerunResultByRuleId = async (
  executionId: number
): Promise<any> => {
  if (!executionId) {
    throw new Error("Execution ID is required");
  }

  const url = `${getRuleParamsUrl}/${executionId}`;

  try {
    const response = await base.get(url);
    return response.data.complete_execution_params;
  } catch (error) {
    console.error("Failed to get comparison rerun result:", error);
    throw error;
  }
};
export const deleteComparisonExecutionbyID = async (
  currentExecutionId: any,
) => {
  try {
    const response = await base.delete(
      `${deleteRuleExecutionbyIdUrl}/${currentExecutionId}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const abortExecution = async (currentExecutionId: any) => {
  try {
    const response = await base.post(
      `${abortExecutionbyIdUrl}/${currentExecutionId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

//get used variables
export const getUsedVariables = async (ruleId: number) => {
  try {
    const response = await base.post(`${getUsedVariablesUrl}/${ruleId}`, {});
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

//get rule execution job status
export const getRuleExecutionJobStatus = async (executionId: number) => {
  try {
    const response = await base.get(
      `${getRuleExecutionJobStatusUrl}/${executionId}`,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const cloneRule = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${cloneRuleUrl}/${reqBody.rule_id}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Reactivate rule
 * @param ruleId - The ID of the rule to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateRule = async (ruleId: string | number) => {
  try {
    const response = await base.put(
      `${reactivateRuleUrl}/${ruleId}/reactivate`,
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating rule:", error);
    throw error;
  }
};
